import { ref } from 'vue';
import { defineStore } from 'pinia';

export const useUiStore = defineStore('ui', () => {
  const showHelp = ref(false);
  const showNav = ref(false);
  const showLeaderboard = ref(false);
  const activeModal = ref<string | null>(null);
  const reloadRequired = ref(false);
  const reloadMessage = ref('Game updated — reload required.');

  function openModal(name: string) {
    activeModal.value = name;
  }

  function closeModal() {
    activeModal.value = null;
  }

  function requireReload(message = 'Game updated — reload required.') {
    reloadRequired.value = true;
    reloadMessage.value = message;
  }

  return { showHelp, showNav, showLeaderboard, activeModal, reloadRequired, reloadMessage, openModal, closeModal, requireReload };
});
